import { haversineDistanceMiles } from './location'

export const parseOfferLocation = (location) => {
  if (!location || typeof location !== 'string') return null

  const parts = location.trim().replace(/,/g, ' ').split(/\s+/)
  if (parts.length < 2) return null

  const first = Number.parseFloat(parts[0])
  const second = Number.parseFloat(parts[1])
  if (!Number.isFinite(first) || !Number.isFinite(second)) return null

  const latitudeFirst = Math.abs(first) <= 90 && Math.abs(second) > 90
  const latitudeSecond = Math.abs(second) <= 90 && Math.abs(first) > 90
  const point = latitudeSecond
    ? { lat: second, lng: first }
    : { lat: first, lng: second }

  if (!latitudeFirst && !latitudeSecond && Math.abs(first) > 90) return null
  if (Math.abs(point.lat) > 90 || Math.abs(point.lng) > 180) return null
  if (point.lat === 0 && point.lng === 0) return null
  return point
}

const toPoint = (latitude, longitude) => {
  const lat = Number.parseFloat(latitude)
  const lng = Number.parseFloat(longitude)
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180 || (lat === 0 && lng === 0)) return null
  return { lat, lng }
}

const uniquePoints = (points) => {
  const seen = new Set()
  return points.filter((point) => {
    if (!point) return false
    const key = `${point.lat}:${point.lng}`
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export const getOfferLocations = (offer = {}) => {
  const localLocations = offer.offerLocation?.local || []
  const points = localLocations.map(({ lat, lng }) => toPoint(lat, lng))

  if (!points.some(Boolean)) {
    points.push(...(offer.locations || []).map(parseOfferLocation))
  }

  if (!points.some(Boolean)) {
    points.push(toPoint(offer.latitude, offer.longitude))
  }

  return uniquePoints(points)
}

export const isPointInBounds = (point, bounds) => {
  if (!bounds) return true
  const withinLatitude = point.lat >= bounds.south && point.lat <= bounds.north
  const withinLongitude = bounds.west <= bounds.east
    ? point.lng >= bounds.west && point.lng <= bounds.east
    : point.lng >= bounds.west || point.lng <= bounds.east
  return withinLatitude && withinLongitude
}

export const getVisibleOfferLocations = (offer, bounds) =>
  getOfferLocations(offer).filter((point) => isPointInBounds(point, bounds))

export const filterOffersToBounds = (offers = [], bounds) =>
  offers.filter((offer) => getVisibleOfferLocations(offer, bounds).length > 0)

export const viewportFromMap = (map) => {
  const bounds = map?.getBounds()
  const center = map?.getCenter()
  if (!bounds || !center) return null

  const northEast = bounds.getNorthEast()
  const southWest = bounds.getSouthWest()
  const latitude = center.lat()
  const longitude = center.lng()
  const radius = Math.max(
    haversineDistanceMiles(latitude, longitude, northEast.lat(), northEast.lng()),
    haversineDistanceMiles(latitude, longitude, southWest.lat(), southWest.lng()),
  )

  if (!Number.isFinite(radius) || radius <= 0) return null
  return {
    latitude: Number(latitude.toFixed(5)),
    longitude: Number(longitude.toFixed(5)),
    radius: Number(radius.toFixed(2)),
    bounds: {
      north: northEast.lat(),
      east: northEast.lng(),
      south: southWest.lat(),
      west: southWest.lng(),
    },
  }
}
